import { render, staticRenderFns } from "./registration-approval.vue?vue&type=template&id=cb52b70c&scoped=true&"
import script from "./registration-approval.ts?vue&type=script&lang=ts&"
export * from "./registration-approval.ts?vue&type=script&lang=ts&"
import style0 from "./registration-approval.scss?vue&type=style&index=0&id=cb52b70c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb52b70c",
  null
  
)

export default component.exports